<template>
  <q-dialog v-model="dialog">
    <q-card style="min-width: 350px">
      <q-card-section>
        <div class="text-h6">{{ title }}</div>
      </q-card-section>

      <q-card-section>
        <q-input ref="input" v-model.trim="name" :readonly="loading" dense autofocus @keyup.enter="save" />
      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn v-close-popup :disable="loading" flat label="Cancel" />

        <q-btn :loading="loading" :disable="!name" flat label="Save" style="width: 150px" @click="save">
          <template #loading>
            <q-spinner-hourglass class="on-left" />
            Loading...
          </template>
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
// Libraries
import { mapActions } from 'vuex'

export default {
  data: () => ({
    name: '',
    id: '',
    loading: false,
    dialog: false,
    title: 'Board Name',
    editMode: false
  }),

  methods: {
    ...mapActions('boards', ['updateBoard', 'createBoard']),

    open({ name, id } = {}, editMode) {
      this.name = name
      this.id = id
      this.dialog = true
      this.editMode = editMode
      if (this.editMode) this.$nextTick(() => this.$refs.input.select())
    },

    async save() {
      const { name, id } = this
      this.loading = true
      if (this.editMode) await this.updateBoard({ id, name })
      else await this.createBoard({ name })
      this.loading = false
      this.dialog = false
    }
  }
}
</script>
